<template>

  <v-combobox
    :search-input.sync="search"
    v-model="selected"
    :items="items"
    label="Кем выдан"
    outlined
    dense
    clearable
    persistent-hint
    @keyup="getPassportIssuedBy(search)"
    @keydown.enter="$emit('enterPressed')"
    ref="inputField" 
    :rules="required!==undefined ? [requiredRule] : []"
  >
      <template v-slot:no-data>
        <template v-if="items.length">      
          <v-list-item v-for="item in items" :key="item" @click="selected=item">
            <v-list-item-content>
              <v-list-item-title>{{ item }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <v-list-item v-else>
          <v-list-item-content>
            <v-list-item-title>
             {{message}}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-combobox>

</template>

<script>
import Api from "@/Api";

export default {
  props: [
    'value', 'required'
  ],
  data: ()=>({
    search: null,
    selected:null,
    items: [],
    message:'Введите запрос для поиска',
    requiredRule: v => !!v || 'Поле обязательно для заполнения',
  }),
  mounted(){
    this.selected = this.value;
  },
  watch: {
    search(){
      this.$emit('update:value',this.search);
    },
    selected() {
      this.$emit('update:value',this.selected);
    }
  },
  methods:{
    focus() {
      this.$refs.inputField.focus();
    },
    getPassportIssuedBy(query, limit=5) {
      this.$tools.debounce(()=>{
        if (query&&query.length>1) {
            let data = {
              query: query, 
              limit: limit
            }
            this.items = []
            this.message = 'Загрузка...'
            Api.service.userProfile.getPassportIssuedBy(data, (response)=>{
              console.log(response)
              if (response.hits !==undefined)
                this.items = response.hits.map(i=>i.code+', '+i.name);
              else 
                this.message = this.response?.message !==undefined ? this.response.message : 'не найдено';
            }, (e)=>{
              console.error(e)
              this.$store.commit('alertError', e.message);
            });         
        }
      }, 500, 'getPassportIssuedBy')
    }
  }
}
</script>
